import React from 'react';

export const Edit = ({ label, onClick } : { label: string, onClick: (() => void) | null }):JSX.Element => {
  if (!onClick) {
    return (
      <span className={'font-bold'}>{label}</span>
    );
  }
  return (
    <a
      className={'font-bold underline hover:no-underline cursor-pointer'}
      onClick={(e: React.SyntheticEvent) => {
        e.stopPropagation();
        onClick();
      }}
    >
      {label}
    </a>
  );
};

export const TableHeader = ({ title }: { title: string }): JSX.Element => (
  <div className={'w-full h-10 transform origin-center -rotate-90 flex items-center'}>
    {title}
  </div>
);
